import React from 'react';

const FormHeader = ({ config }) => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">
        {config.configuration.meta?.displayName || config.name}
      </h1>
      {config.configuration.meta?.purpose && (
        <p className="text-gray-600">{config.configuration.meta.purpose}</p>
      )}
      {config.configuration.ui?.instructions && (
        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-md">
          {config.configuration.ui.instructions.map((instruction, index) => (
            <p key={index} className="text-blue-800">{instruction}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default FormHeader;